module.exports = __webpack_public_path__ + "img/telegram.ea33774e.jpg";